<template>
    <v-card>
        <v-card-title>
            {{ title }}
            <v-btn @click="close" icon class="mr-auto">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text class="p-3" style="height: calc(100vh - 140px)">
            <v-slide-group
                v-model="gallertySlider"
                class="pa-3"
                active-class="success"
                show-arrows
                v-if="type == 0"
            >
                <v-slide-item
                    v-for="(img, index) in imagesGallery"
                    :key="index"
                >
                    <v-card
                        class="ma-3"
                        @click="select(index)"
                        :class="{'selected': selectedImage == index}"
                    >
                        <img
                            height="200" width="200" 
                            :src="img.replace('~', domainHost)"
                            style="object-fit: cover"
                        />
                    </v-card>
                </v-slide-item>
            </v-slide-group>
            <v-row 
                v-else
            >
                <v-col
                    cols="3" sm="1"
                    v-for="(img, index) in imagesGallery"
                    :key="index"
                    @click="select(index)"
                    :class="{'selected': selectedImage == index}"
                    class="text-center align-items-center d-flex justify-content-center border"
                    :style="'height:calc(100vw *' + width < 600 ? 25 : 8.3333333333 + '/ 100)'"
                >
                    <img style="max-width: 36px; width: 200%; object-fit: cover" :src="img.replace('~', domainHost)" />
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions class="justify-content-end">
            <v-btn color="success" @click="selectImage">تم</v-btn>
            <v-btn color="error" @click="close" outlined>عودة</v-btn>
        </v-card-actions>
    </v-card>
</template>
<style lang="scss" scoped>
    img{
        user-select: none;
    }
.selected {
    position: relative;
    &:after {
        transition: all .7s linear;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: #28a74570
    }
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
    props: {
        title: String,
        type: Number,
        width: window.innerWidth
    },
    data: () => ({
        gallertySlider: null,
        selectedImage: -1
    }),
  computed: {
    ...mapGetters(["domainHost", "imagesGallery"]),
  },
  methods: {
    ...mapActions(["ActionCategory", "DeleteCategory"]),
    select(index) {
        this.selectedImage = this.selectedImage ==  index ? -1 : index
    },
    close() {
        this.$emit('close')
        this.selectedImage =  -1 
    },
    selectImage() {
        this.$emit('selectImage', this.imagesGallery[this.selectedImage], this.type)
        this.selectedImage =  -1
        this.close()
    }
  }
}
</script>